function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.2 26.4l34.2-11.5V0L0 38.3v29.2l113.4 38.3V90.9L79.2 79.4l-11.8-4L.7 52.9l66.7-22.5zM0 126.7h113.4v14.1H0z"
});

var Svg1 = function Svg1(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 113.4 140.8"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMTMuNCAxNDAuOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTEzLjQgMTQwLjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBvbHlnb24gcG9pbnRzPSI3OS4yLDI2LjQgMTEzLjQsMTQuOSAxMTMuNCwwIDAsMzguMyAwLDY3LjUgMTEzLjQsMTA1LjggMTEzLjQsOTAuOSA3OS4yLDc5LjQgNjcuNCw3NS40IDAuNyw1Mi45IDY3LjQsMzAuNCAiLz4KPHJlY3QgeT0iMTI2LjciIHdpZHRoPSIxMTMuNCIgaGVpZ2h0PSIxNC4xIi8+Cjwvc3ZnPgo=";
export { Svg1 as ReactComponent };